import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cart"
export default class extends Controller {
  static targets = ["submitButton"]

  async add(event) {
    event.preventDefault()

    const form = event.target.closest("form") || this.element
    const button = this.hasSubmitButtonTarget ? this.submitButtonTarget : null

    if (button) {
      button.textContent = "Adding..."
      button.disabled = true
    }

    const formData = new FormData(form)
    const data = Object.fromEntries(formData.entries())

    try {
      const res = await fetch(form.action, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(data)
      })

      if (res.ok) {
        const resData = await res.json()
        this._updateCartBadge(resData)
        this._showToast("Thêm vào giỏ hàng thành công")
      } else {
        const error = await res.json().catch(() => ({}))
        alert("Error: " + (error.message || "Unknown error"))
      }
    } catch (err) {
      alert("Connection error")
    } finally {
      if (button) {
        button.textContent = "Add to bag"
        button.disabled = false
      }
    }
  }

  _updateCartBadge(resData) {
    let count = 0
    if (resData && resData.items) {
      count = resData.items.reduce((sum, item) => sum + (item.quantity || 0), 0)
    }

    // Try to find cart badge by ID first (Turbo-friendly), then fallback to selector
    let badge = document.getElementById("cart-item-count")

    if (!badge) {
      const cartLink = document.querySelector('a[href="/cart"]')
      if (cartLink) {
        badge = cartLink.querySelector("span.absolute")
        if (!badge && count > 0) {
          badge = document.createElement("span")
          badge.id = "cart-item-count"
          badge.className = "absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-indigo-600 text-[10px] font-bold text-white"
          cartLink.appendChild(badge)
        }
      }
    }

    if (badge) {
      if (count > 0) {
        badge.innerText = count
        badge.style.display = "flex"
      } else {
        badge.style.display = "none"
      }
    }
  }

  _showToast(message) {
    const toast = document.createElement("div")
    toast.innerText = message

    // Use inline styles to guarantee visibility — no Tailwind dependency
    Object.assign(toast.style, {
      position: "fixed",
      top: "16px",
      left: "50%",
      transform: "translateX(-50%) translateY(-100%)",
      zIndex: "99999",
      background: "#22c55e",
      color: "#fff",
      padding: "12px 24px",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      fontSize: "14px",
      fontWeight: "500",
      whiteSpace: "nowrap",
      opacity: "0",
      transition: "all 0.3s ease"
    })

    document.body.appendChild(toast)

    // Slide in
    requestAnimationFrame(() => {
      toast.style.opacity = "1"
      toast.style.transform = "translateX(-50%) translateY(0)"
    })

    // Slide out after 3s
    setTimeout(() => {
      toast.style.opacity = "0"
      toast.style.transform = "translateX(-50%) translateY(-100%)"
      setTimeout(() => toast.remove(), 300)
    }, 3000)
  }
}
